import { Link } from 'react-router-dom'
import PolicyPage, { PolicySection, PolicyList } from 'components/compliance/policy-page'
import compliance from 'data/compliance.json'

const { contact, payments } = compliance
const handlesAnyPayments = payments.collectsTuition.value
  || payments.collectsDeposits.value
  || payments.collectsVisaFees.value

function Payments() {
  return (
    <PolicyPage
      title='Tuition and Student Payments'
      description='Whether UHDSS collects tuition fees, deposits or visa fees, and how students should pay institutions and government authorities.'
      intro='This page explains who you pay, and what we will tell you if we are ever authorised to handle a payment on behalf of another organisation.'
    >
      <PolicySection title='Who you pay'>
        <p className='dark-blue fs-6'>
          You should pay tuition fees and institution deposits using the payment method that your
          university, college or education provider has officially authorised. Where an institution
          uses an approved international payment provider, we will point you to that provider.
        </p>
        <p className='dark-blue fs-6'>
          Visa, embassy, consular, biometric and other government fees are paid directly to the
          authority or to its official service provider, through its own channels.
        </p>
      </PolicySection>

      <PolicySection title={handlesAnyPayments ? 'Payments we handle' : 'Payments we do not handle'}>
        {handlesAnyPayments ? (
          <p className='dark-blue fs-6'>
            UHDSS handles some payments on behalf of other organisations. Where we do, we will give
            you the details set out in the next section in writing before you transfer anything.
          </p>
        ) : (
          <>
            <PolicyList items={[
              'UHDSS does not collect university tuition fees.',
              'UHDSS does not collect university deposits.',
              'UHDSS does not collect visa or other government fees.',
              'This website has no online payment or checkout step.'
            ]} />
            <p className='dark-blue fs-6'>
              UHDSS does not treat tuition fees, visa fees, government fees or institution deposits
              as money belonging to UHDSS, and we will never ask you to pay funds of this kind into
              a personal account. If anyone asks you to do so in our name, please stop and contact
              us at{' '}
              <a className='text-decoration-none' href={`mailto:${contact.generalEmail}`}>{contact.generalEmail}</a>.
            </p>
          </>
        )}
      </PolicySection>

      <PolicySection title='If we are authorised to handle a payment'>
        <p className='dark-blue fs-6'>
          If UHDSS is specifically authorised in writing to receive or pass on a payment for another
          organisation, we will tell you, before you transfer anything:
        </p>
        <PolicyList items={payments.authorisedFacilitationDisclosures} />
        <p className='dark-blue fs-6'>
          Where we receive an authorised payment directly, we will give you a receipt or another
          appropriate record of the payment.
        </p>
      </PolicySection>

      <PolicySection title='Protecting yourself'>
        <PolicyList items={[
          'Check payment instructions with the institution or authority before you transfer money.',
          'Keep every receipt and confirmation you are given.',
          'Be careful with any message that asks you to change a payment destination at short notice.',
          'Ask us if anything about a payment request seems unclear or unexpected.'
        ]} />
      </PolicySection>

      <PolicySection title='Our own charges'>
        <p className='dark-blue fs-6'>
          What we charge for our own services, and what we provide free of charge, is set out in our{' '}
          <Link className='text-decoration-none' to='/fees'>fees and service charges policy</Link>.
        </p>
      </PolicySection>
    </PolicyPage>
  )
}

export default Payments
